<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import { mapState } from "vuex";
import moment from "moment";
import Banners from "@/components/widgets/banners";
import Stat from "@/components/widgets/stat";
import ChartBonus from "@/components/widgets/chart-bonus";
import Binary from "@/components/widgets/network-matriz";
import Graduation from "@/components/home-graduation";

export default {
  locales: {
    pt: {
    },
    es: {
    }
  },
  components: {
    Layout,
    Banners,
    Stat,
    ChartBonus,
    Binary,
    Graduation,
  },
  computed: {
    ...mapState({
      account: state => state.account
    }),
    sideLabel() {
      return { l: "Linha 1", r: "Linha 2", m: "Balanceamento" }[this.side.value] || "";
    },
  },
  data() {
    return {
      month_year: moment().format("MM/YY"),

      monthly: {
        status: "inactive",
        graduation: {
          status: "inactive",
          date: moment().format("DD/MM/YYYY"),
        },
        date: moment().format("DD/MM/YYYY"),
        days: 0,
      },

      total: {
        bonus: "R$ -,--",
        balance: "R$ -,--",
        elite: "R$ -,--",
        premium: "R$ -,--",
      },

      graduation: {
        id: null,
        name: '-',
        image: null
      },

      statData: null,
      wallets: null,

      cart: {
        items: {
          loading: true,
          total: 0,
          list: null
        },
        points: {
          binary: 0,
          unilevel: 0,
          graduation: 0,
        },
        subtotal: '0.00',
        sale: '0.00',
        shipping: {
          method: '-',
          value: '-',
        },
        total: '0.00'
      },

      binary: {
        resume: {
          points: {
            left: "-",
            right: "-",
          },
          personal: "-",
          minor: "-",
          total: "-",
          plan: {
            status: "no",
            ceiling: "0,00",
          },
        },

        left: {
          current: '0',
          users: '0',
        },
        right: {
          current: '0',
          users: '0',
        },

        tree: null,
        levels: [],
        list: null,
      },

      side: {
        modal: false,
        loading: false,
        unlocked: false,
        value: "m",
      },

      referral: {
        sponsored: process.env.VUE_APP_URL_PAINEL + this.$store.state.account.user.username,
        ecommerce: process.env.VUE_APP_URL_ECOMMERCE + this.$store.state.account.user.username,
      },
    };
  },
  methods: {
    getMonthly() {
      api.get("reports/monthly").then((response) => {
        this.monthly.status = response.data.status;
        this.monthly.graduation = response.data.graduation;
        this.monthly.date = response.data.date;
        this.monthly.days = response.data.days;
        this.getStatData();
      });
    },
    getGraduation() {
      api
        .get('reports/graduation')
        .then(response => {
          if (response.data.status == 'success') {
            this.graduation.id = response.data.current.id
            this.graduation.name = response.data.current.name
            this.graduation.image = response.data.current.image
          }
        })
    },
    getTotalBonus() {
      api
        .get('reports/bonus/total')
        .then(response => {
          if (response.data.status == 'success') {
            this.total.bonus = this.$options.filters.currency(response.data.total)
            this.getStatData();
          }
        })
    },
    getTotalBalance() {
      api
        .get('wallet/balance/network')
        .then(response => {
          if (response.data.status == 'success') {
            this.total.balance = this.$options.filters.currency(response.data.balance)
            this.getStatData();
          }
        })
    },
    getTotalElite() {
      api
        .get('reports/elite')
        .then(response => {
          if (response.data.status == 'success') {
            this.total.elite = this.$options.filters.points(response.data.accumulated)
            this.getStatData();
          }
        })
    },
    getTotalPremium() {
      api
        .get('reports/premium')
        .then(response => {
          if (response.data.status == 'success') {
            this.total.premium = this.$options.filters.points(response.data.accumulated)
            this.getStatData();
          }
        })
    },
    getStatData() {
      this.statData = [
        {
          type: "line",
          title: "Fase",
          value: this.account.user.package.name,
          icon: "bx-package",
        },
        {
          type: "line",
          icon: "bx-time-five",
          title: "Status",
          value: this.monthly.status,
          date: this.monthly.date,
        },
        {
          type: "line",
          icon: "bx-trophy",
          title: "Plano de Carreira",
          value: this.monthly.graduation.status,
          date: this.monthly.graduation.date,
        },
        {
          type: "line",
          icon: "bx-trophy",
          title: "Graduação",
          value: this.graduation.name,
        },
        {
          type: "line",
          icon: "bx-dollar",
          title: "Total de Bônus",
          value: this.total.bonus,
        },
        {
          type: "line",
          icon: "bx-wallet",
          title: "Saldo Disponível",
          value: this.total.balance,
        },
        {
          type: "line",
          icon: "bx-star",
          title: "Pontos Elite",
          value: this.total.elite,
        },
        {
          type: "line",
          icon: "bx-crown",
          title: "Pontos Premium",
          value: this.total.premium,
        }
      ]
    },
    getCart() {
      if (!localStorage.cart) {
        api
          .get('store/cart')
          .then(response => {
            if (response.data.status == 'success') {
              this.setStorage(response.data)
            }
          })
          .catch(error => {
            this.cart.errored = error
          })
      } else {
        this.cart = JSON.parse(localStorage.cart)
      }
    },
    setStorage(data) {
      this.cart.items.total = data.items.total
      this.cart.items.list = data.items.list
      this.cart.subtotal = data.subtotal
      this.cart.sale = data.sale
      this.cart.shipping = data.shipping
      this.cart.total = data.total

      localStorage.cart = JSON.stringify(this.cart)
    },
    getBinarySide() {
      api
        .get('network/binary/side')
        .then(response => {
          if (response.data.status == 'success') {
            this.side.value = response.data.side
            this.side.unlocked = response.data.unlocked
          }
        })
    },
    changeBinarySide() {
      this.side.loading = false
      this.side.modal = true
    },
    saveBinarySide() {
      this.side.loading = true
      api
        .post('network/binary/side', {
          side: this.side.value
        })
        .then(response => {
          if (response.data.status == 'success') {
            this.side.modal = false
            this.$toast.success(response.data.message)
            this.getBinarySide()
          } else {
            this.$toast.error(response.data.message)
          }
        })
        .finally(() => {
          this.side.loading = false
        })
    },
    getBinary() {
      api
        .get('network/binary')
        .then(response => {
          if (response.data.status == 'success') {
            this.binary.resume.points.left = this.$options.filters.points(response.data.resume.points.left);
            this.binary.resume.points.right = this.$options.filters.points(response.data.resume.points.right);
            this.binary.resume.personal = this.$options.filters.points(response.data.resume.personal);
            this.binary.resume.minor = this.$options.filters.points(response.data.resume.minor);
            this.binary.resume.total = this.$options.filters.points(response.data.resume.total);
            this.binary.resume.plan.status = response.data.resume.plan.status;
            this.binary.resume.plan.ceiling = response.data.resume.plan.ceiling;

            this.binary.left.current = response.data.points.current.left
            this.binary.left.users = response.data.users.left

            this.binary.right.current = response.data.points.current.right
            this.binary.right.users = response.data.users.right

            this.binary.username = response.data.user.username
            this.binary.name = response.data.user.name
            this.binary.image = response.data.user.image

            this.binary.tree = response.data.tree

            this.binary.levels = response.data.levels
            this.binary.list = response.data.list
          }
        })
        .catch(error => {
          this.errored = error
          this.loading = false
        })
        .finally(() => {
          this.errored = false
          this.loading = false
        })
    }
  },
  mounted() {
    this.getMonthly()
    this.getGraduation()
    this.getTotalBonus()
    this.getTotalBalance()
    this.getTotalElite()
    this.getTotalPremium()
    this.getStatData()
    this.getCart()
    this.getBinary()
    this.getBinarySide()
  }
};
</script>

<template>
  <Layout>
    <div class="mb-3 border bg-soft-danger p-3 rounded d-flex align-items-center" v-if="monthly.status == 'inactive'">
      <div>
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" style="fill: currentColor;">
          <path
            d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zM4 12c0-1.846.634-3.542 1.688-4.897l11.209 11.209A7.946 7.946 0 0 1 12 20c-4.411 0-8-3.589-8-8zm14.312 4.897L7.103 5.688A7.948 7.948 0 0 1 12 4c4.411 0 8 3.589 8 8a7.954 7.954 0 0 1-1.688 4.897z">
          </path>
        </svg>
      </div>
      <div class="flex-fill ml-2 font-size-14">
        Você está inativo, atualize o seu consumo mensal para receber seus bônus diários!
      </div>
    </div>
    <div class="mb-3 border bg-soft-warning p-3 rounded d-flex align-items-center" v-else-if="monthly.status == 'active' && monthly.days <= 5">
      <div>
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" style="fill: currentColor;">
          <path
            d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zM4 12c0-1.846.634-3.542 1.688-4.897l11.209 11.209A7.946 7.946 0 0 1 12 20c-4.411 0-8-3.589-8-8zm14.312 4.897L7.103 5.688A7.948 7.948 0 0 1 12 4c4.411 0 8 3.589 8 8a7.954 7.954 0 0 1-1.688 4.897z">
          </path>
        </svg>
      </div>
      <div class="flex-fill ml-2 font-size-14">
        Você ficará inativo em {{ monthly.days }} dias, atualize o seu consumo mensal para continuar recebendo seus bônus!
      </div>
    </div>

    <router-link v-if="cart.items.total > 0" to="/store/cart" class="text-dark">
      <div class="card">
        <div class="card-body bg-soft-warning rounded p-0">
          <div class="d-flex align-items-center">
            <img class="rounded-circle header-profile-user m-2 mx-2" :src="cart.items.list[Object.keys(cart.items.list)[0]].image" width="30px" height="30px">
            <div class="py-3">Você deixou alguns produtos em seu carrinho, clique aqui para finalizar o seu pedido!</div>
          </div>
        </div>
      </div>
    </router-link>

    <Banners></Banners>

    <div class="card mb-1">
      <div class="card-body p-1 d-flex justify-content-between align-items-center">
        <div class="mr-2">
          <div class="bg-light rounded p-2">
            <i class="bx bx-link-alt font-size-24 align-middle"></i>
          </div>
        </div>
        <h5 class="flex-fill m-0 align-items-center font-size-16">
          Link de indicação de cadastro
        </h5>
        <div class="d-flex align-items-center">
          <div class="ml-1">
            <ShareNetwork network="whatsapp" url="" :title="referral.sponsored">
              <div class="bg-light rounded p-2"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: #322F4F;">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M18.403 5.633A8.919 8.919 0 0 0 12.053 3c-4.948 0-8.976 4.027-8.978 8.977 0 1.582.413 3.126 1.198 4.488L3 21.116l4.759-1.249a8.981 8.981 0 0 0 4.29 1.093h.004c4.947 0 8.975-4.027 8.977-8.977a8.926 8.926 0 0 0-2.627-6.35m-6.35 13.812h-.003a7.446 7.446 0 0 1-3.798-1.041l-.272-.162-2.824.741.753-2.753-.177-.282a7.448 7.448 0 0 1-1.141-3.971c.002-4.114 3.349-7.461 7.465-7.461a7.413 7.413 0 0 1 5.275 2.188 7.42 7.42 0 0 1 2.183 5.279c-.002 4.114-3.349 7.462-7.461 7.462m4.093-5.589c-.225-.113-1.327-.655-1.533-.73-.205-.075-.354-.112-.504.112s-.58.729-.711.879-.262.168-.486.056-.947-.349-1.804-1.113c-.667-.595-1.117-1.329-1.248-1.554s-.014-.346.099-.458c.101-.1.224-.262.336-.393.112-.131.149-.224.224-.374s.038-.281-.019-.393c-.056-.113-.505-1.217-.692-1.666-.181-.435-.366-.377-.504-.383a9.65 9.65 0 0 0-.429-.008.826.826 0 0 0-.599.28c-.206.225-.785.767-.785 1.871s.804 2.171.916 2.321c.112.15 1.582 2.415 3.832 3.387.536.231.954.369 1.279.473.537.171 1.026.146 1.413.089.431-.064 1.327-.542 1.514-1.066.187-.524.187-.973.131-1.067-.056-.094-.207-.151-.43-.263">
                  </path>
                </svg>
              </div>
            </ShareNetwork>
          </div>
          <div class="ml-1">
            <button class="btn btn-link p-0 m-0" v-clipboard:copy="referral.sponsored
              " v-on:click="$toast.success('Copiado!');">
              <div class="bg-light rounded p-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: #322F4F;">
                  <path
                    d="M20 2H10c-1.103 0-2 .897-2 2v4H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2v-4h4c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM4 20V10h10l.002 10H4zm16-6h-4v-4c0-1.103-.897-2-2-2h-4V4h10v10z">
                  </path>
                </svg>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body p-1 d-flex justify-content-between align-items-center">
        <div class="mr-2">
          <div class="bg-light rounded p-2">
            <i class="bx bx-link-alt font-size-24 align-middle"></i>
          </div>
        </div>
        <h5 class="flex-fill m-0 align-items-center font-size-16">
          Link de indicação da loja
        </h5>
        <div class="d-flex align-items-center">
          <div class="ml-1">
            <ShareNetwork network="whatsapp" url="" :title="referral.ecommerce">
              <div class="bg-light rounded p-2"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: #322F4F;">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M18.403 5.633A8.919 8.919 0 0 0 12.053 3c-4.948 0-8.976 4.027-8.978 8.977 0 1.582.413 3.126 1.198 4.488L3 21.116l4.759-1.249a8.981 8.981 0 0 0 4.29 1.093h.004c4.947 0 8.975-4.027 8.977-8.977a8.926 8.926 0 0 0-2.627-6.35m-6.35 13.812h-.003a7.446 7.446 0 0 1-3.798-1.041l-.272-.162-2.824.741.753-2.753-.177-.282a7.448 7.448 0 0 1-1.141-3.971c.002-4.114 3.349-7.461 7.465-7.461a7.413 7.413 0 0 1 5.275 2.188 7.42 7.42 0 0 1 2.183 5.279c-.002 4.114-3.349 7.462-7.461 7.462m4.093-5.589c-.225-.113-1.327-.655-1.533-.73-.205-.075-.354-.112-.504.112s-.58.729-.711.879-.262.168-.486.056-.947-.349-1.804-1.113c-.667-.595-1.117-1.329-1.248-1.554s-.014-.346.099-.458c.101-.1.224-.262.336-.393.112-.131.149-.224.224-.374s.038-.281-.019-.393c-.056-.113-.505-1.217-.692-1.666-.181-.435-.366-.377-.504-.383a9.65 9.65 0 0 0-.429-.008.826.826 0 0 0-.599.28c-.206.225-.785.767-.785 1.871s.804 2.171.916 2.321c.112.15 1.582 2.415 3.832 3.387.536.231.954.369 1.279.473.537.171 1.026.146 1.413.089.431-.064 1.327-.542 1.514-1.066.187-.524.187-.973.131-1.067-.056-.094-.207-.151-.43-.263">
                  </path>
                </svg>
              </div>
            </ShareNetwork>
          </div>
          <div class="ml-1">
            <button class="btn btn-link p-0 m-0" v-clipboard:copy="referral.ecommerce
              " v-on:click="$toast.success('Copiado!');">
              <div class="bg-light rounded p-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: #322F4F;">
                  <path
                    d="M20 2H10c-1.103 0-2 .897-2 2v4H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2v-4h4c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM4 20V10h10l.002 10H4zm16-6h-4v-4c0-1.103-.897-2-2-2h-4V4h10v10z">
                  </path>
                </svg>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div v-for="(stat, index) of statData" :key="index" class="col-md-3">
        <Stat :type="stat.type" :icon="stat.icon" :title="stat.title" :value="stat.value" :date="stat.date" :trophy="stat.trophy" />
      </div>
    </div>

    <div class="row d-none">
      <div class="col-md-12 col-lg-6">
        <fieldset class="card-h-fix">
          <legend>
            Fases <sup class="font-weight-light">{{ month_year }}</sup>
          </legend>
          <div class="d-flex justify-content-center card-h-fix">
            <ChartBonus type="matriz" />
          </div>
        </fieldset>
      </div>
      <div class="col-md-12 col-lg-6">
        <fieldset class="card-h-fix">
          <legend>
            Ganho Diário <sup class="font-weight-light">{{ month_year }}</sup>
          </legend>
          <div class="d-flex justify-content-center card-h-fix">
            <ChartBonus type="diario" />
          </div>
        </fieldset>
      </div>
    </div>


    <div class="page-title-box d-md-flex justify-content-between">
      <div>
        <h3>Matriz 2x15 Bilateral</h3>
        <p></p>
      </div>
    </div>

    <fieldset class="pb-0">
      <legend class="d-flex align-items-center">
        Pontos
        <button type="button" class="btn btn-sm btn-light rounded-pill ml-2 d-inline-flex align-items-center"
          title="Lado do binário" v-on:click="changeBinarySide()">
          <span class="font-size-12 text-uppercase font-weight-bold mr-1">{{ sideLabel }}</span>
          <i class="bx bx-cog font-size-18"></i>
        </button>
      </legend>
      <b-modal v-model="side.modal" title="Lado do Binário" hide-footer>
        <b-form @submit.prevent="saveBinarySide()">
          <b-form-group label="Escolha o lado" label-for="binary-side">
            <select id="binary-side" v-model="side.value" class="custom-select mb-2">
              <option value="l" :disabled="!side.unlocked">Linha 1</option>
              <option value="r" :disabled="!side.unlocked">Linha 2</option>
              <option value="m">Balanceamento</option>
            </select>
            <small v-if="!side.unlocked" class="text-muted">
              As opções Linha 1 e Linha 2 serão liberadas quando você tiver 2 indicados diretos no binário.
            </small>
          </b-form-group>
          <b-button :disabled="side.loading" type="submit" variant="default" size="lg">
            Salvar
            <b-spinner v-if="side.loading" small class="ml-2 align-middle" role="status"></b-spinner>
          </b-button>
        </b-form>
      </b-modal>
      <div class="row">
        <div class="col-lg-2 col-md-4 col-6 mb-3">
          <div class="d-flex align-items-center">
            <div>
              <div class="bg-light rounded py-1 px-2">
                <i class="bx bx-subdirectory-left font-size-24 my-1 align-middle"></i>
              </div>
            </div>
            <div class="flex-fill ml-2">
              <h5 class="mb-0 notranslate font-weight-bold">{{ binary.resume.points.left }}</h5>
              <p class="font-weight-medium mb-0 text-uppercase font-weight-light font-size-12">Linha 1</p>
            </div>
          </div>
        </div>
        <div class="col-lg-2 col-md-4 col-6 mb-3">
          <div class="d-flex align-items-center">
            <div>
              <div class="bg-light rounded py-1 px-2">
                <i class="bx bx-subdirectory-right font-size-24 my-1 align-middle"></i>
              </div>
            </div>
            <div class="flex-fill ml-2">
              <h5 class="mb-0 notranslate font-weight-bold">{{ binary.resume.points.right }}</h5>
              <p class="font-weight-medium mb-0 text-uppercase font-weight-light font-size-12">Linha 2</p>
            </div>
          </div>
        </div>
        <div class="col-lg-2 col-md-4 col-6 mb-3">
          <div class="d-flex align-items-center">
            <div>
              <div class="bg-light rounded py-1 px-2">
                <i class="bx bx-check-double font-size-24 my-1 align-middle"></i>
              </div>
            </div>
            <div class="flex-fill ml-2">
              <h5 class="mb-0 notranslate font-weight-bold">{{ binary.resume.personal }}</h5>
              <p class="font-weight-medium mb-0 text-uppercase font-weight-light font-size-12">Pontos Pessoais</p>
            </div>
          </div>
        </div>
        <div class="col-lg-2 col-md-4 col-6 mb-3">
          <div class="d-flex align-items-center">
            <div>
              <div class="bg-light rounded py-1 px-2">
                <i class="bx bx-dollar font-size-24 my-1 align-middle"></i>
              </div>
            </div>
            <div class="flex-fill ml-2">
              <h5 class="mb-0 notranslate font-weight-bold">{{ binary.resume.minor }}</h5>
              <p class="font-weight-medium mb-0 text-uppercase font-weight-light font-size-12">L. Menor</p>
            </div>
          </div>
        </div>
        <div class="col-lg-2 col-md-4 col-6 mb-3">
          <div class="d-flex align-items-center">
            <div>
              <div class="bg-light rounded py-1 px-2">
                <i class="bx bx-dollar font-size-24 my-1 align-middle"></i>
              </div>
            </div>
            <div class="flex-fill ml-2">
              <h5 class="mb-0 notranslate font-weight-bold">{{ binary.resume.total }}</h5>
              <p class="font-weight-medium mb-0 text-uppercase font-weight-light font-size-12">Total</p>
            </div>
          </div>
        </div>
        <div class="col-lg-2 col-md-4 col-6 mb-3">
          <div class="d-flex align-items-center">
            <div>
              <div class="bg-light rounded py-1 px-2">
                <i class="bx bx-dollar font-size-24 my-1 align-middle"></i>
              </div>
            </div>
            <div class="flex-fill ml-2">
              <h5 class="mb-0 notranslate font-weight-bold" v-if="binary.resume.plan.status == 'yes' && binary.resume.plan.ceiling > 0">{{ binary.resume.plan.ceiling | currency }}</h5>
              <h5 class="mb-0 notranslate font-weight-bold" v-else-if="binary.resume.plan.status == 'no' && binary.resume.plan.ceiling > 0">R$ 0,00</h5>
              <h5 class="mb-0 notranslate font-weight-bold font-size-16" v-else>Ilimitado</h5>
              <p class="font-weight-medium mb-0 text-uppercase font-weight-light font-size-12">Teto</p>
            </div>
          </div>
        </div>
      </div>
    </fieldset>

    <div class="card">
      <div class="card-body">
        <Binary :data="binary.tree"></Binary>
      </div>
    </div>

    <fieldset>
      <legend>Níveis</legend>
      <table class="table table-centered table-nowrap">
        <thead class="thead-light">
          <tr>
            <th class="text-center">Nível</th>
            <th class="text-center">Qtd Atual</th>
            <th class="text-center">Qtd Máxima</th>
            <th class="text-center">Falta Completar</th>
            <th class="text-center">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in binary.levels" :key="row.level">
            <td class="text-center">{{ row.level }}º</td>
            <td class="text-center">{{ row.current | points }}</td>
            <td class="text-center">{{ row.total | points }}</td>
            <td class="text-center">{{ row.missing | points }}</td>
            <td class="text-center">
              <span class="badge badge-soft-success font-size-12" v-if="row.missing == '0'">COMPLETO</span>
              <span class="badge badge-soft-warning font-size-12" v-else>INCOMPLETO</span>
            </td>
          </tr>
        </tbody>
      </table>
    </fieldset>

    <fieldset>
      <legend>Lista</legend>

      <div v-if="!binary.list" class="text-center">
        <b-spinner variant="default" role="status"></b-spinner>
      </div>

      <div v-else-if="binary.list && binary.list.length == 0">
        <div class="text-center">
          <i class="far fa-sad-cry font-size-24"></i><br>
          nenhum registro encontrado
        </div>
      </div>

      <div v-else class="table-responsive">
        <table class="table table-centered table-nowrap">
          <thead class="thead-light">
            <tr>
              <th>Usuário</th>
              <th>Nome</th>
              <th>Patrocinador</th>
              <th>Fase</th>
              <th>Nível</th>
              <th>Lado</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(td, index) in binary.list" :key="index">
              <td>{{ td.username }}</td>
              <td>{{ td.name }}</td>
              <td>{{ td.sponsor }}</td>
              <td>{{ td.plan }}</td>
              <td>{{ td.level }}</td>
              <td>
                <span class="badge badge-soft-default font-size-12" v-if="td.side == 'l'">ESQUERDO</span>
                <span class="badge badge-soft-default font-size-12" v-else-if="td.side == 'r'">DIREITO</span>
              </td>
              <td>
                <div v-if="td.monthly.status == 'active'"><span class="badge badge-soft-success font-size-12">ATIVO</span> – <span class="font-size-12">{{ td.monthly.date }}</span></div>
                <span v-else-if="td.monthly.status == 'inactive'" class="badge badge-soft-danger font-size-12">INATIVO</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </fieldset>

    <Graduation />
  </Layout>
</template>